import BreadCrumb from "components/common/BreadCrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { EmployeeAdvancesTable } from "./EmployeeAdvancesTable";
import { Link } from "react-router-dom";
import { getDocumentTitle } from "utils/helpers";
import { useAccess } from "features/Authentication/hooks/useAccess";
import { Permissions } from "features/RolesAndPermissions/constants/permission.constants";
import AdvanceSummaryWidgets from "components/common/AdvanceSummaryWidgets";
import { getEmployeeAdvanceSummary } from "features/EmployeeAdvances/services/EmployeeAdvanceService";
import { employeeAdvanceStatusMap } from "features/EmployeeAdvances/constants/employee-advance.constants";

const EmployeeAdvanceList = () => {
  document.title = getDocumentTitle("Employee Advances");
  const { can } = useAccess();
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Employee Advances" pageTitle="Finance" />
        <AdvanceSummaryWidgets
          fetchSummary={getEmployeeAdvanceSummary}
          statusLabelMap={employeeAdvanceStatusMap}
        />
        <Card>
          <CardHeader className="d-flex justify-content-between">
            <h5 className="card-title mb-0">Employee Advance List</h5>
            {can(Permissions.EMPLOYEE_ADVANCE.CREATE) ? (
              <Link to="/finance/employee-advances/create" className="btn btn-primary">
                <i className="ri-add-line align-bottom me-1"></i> New Employee Advance
              </Link>
            ) : null}
          </CardHeader>
          <CardBody>
            <EmployeeAdvancesTable />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default EmployeeAdvanceList;
